//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import {PublicAppLayout} from 'app_components/layouts/public'
import AcademicOfferModule from 'app_components/modules/academic/academicOffer'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../shopScreen.scss'

// @ADD Component types
interface IShopScreenLayoutProps {}

const ShopScreenLayout: React.FC<IShopScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppLayout>
      <AcademicOfferModule
        nPerPage={15}
        showPagination={true}
        showCategories={true}
       />
    </PublicAppLayout>
  )
}

export default ShopScreenLayout
